import { render, staticRenderFns } from "./status-results.vue?vue&type=template&id=a94841d8&scoped=true&"
import script from "./status-results.vue?vue&type=script&lang=js&"
export * from "./status-results.vue?vue&type=script&lang=js&"
import style0 from "./status-results.vue?vue&type=style&index=0&id=a94841d8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94841d8",
  null
  
)

export default component.exports